export class MimeTypeHelper {
  public static getMimeType(type: string): string {
    if (type === 'jpg') {
      return 'image/jpeg';
    }
    if (type === 'jpeg') {
      return 'image/jpeg';
    }
    if (type === 'png') {
      return 'image/png';
    }
    if (type === 'bmp') {
      return 'image/bmp';
    }
    if (type === 'pdf') {
      return 'application/pdf';
    }
    if (type === 'xlsx') {
      return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }
    if (type === 'xls') {
      return 'application/vnd.ms-excel';
    }
    if (type === 'csv') {
      return 'text/csv';
    }
    if (type === 'xml') {
      return 'application/xml';
    }
    if (type === 'txt') {
      return 'text/plain';
    }
    if (type === 'edi') {
      return 'application/edi-x12';
    }
    if (type === 'json') {
      return 'application/json';
    }
    if (type === 'cer') {
      return 'application/x-x509-ca-cert';
    }
    if (type === 'pem') {
      return 'application/x-pem-file';
    }
    if (type === 'pfx') {
      return 'application/x-pkcs12';
    }
    if (type === 'p12') {
      return 'application/x-pkcs12';
    }
    if (type === 'crt') {
      return 'application/x-x509-ca-cert';
    }
    if (type === 'p7b') {
      return 'application/x-pkcs7-certificates';
    }
    if (type === 'p7c') {
      return 'application/x-pkcs7-mime';
    }
    if (type === 'pub') {
      return 'application/x-pkcs7-certreqresp';
    }
    if (type === 'ppk') {
      return 'application/x-ssh';
    }
    if (type === 'html' || type === 'htm') {
      return 'text/html';
    }

    return 'application/' + type;
  }
}
